import Videos from "./videoLayout";
import Conversations from "./conversations";
import Socket from "./Socket";
import DeviceManager from "../room/devices";
import LocalRecording from "./local-recording";
import Chat from "./chat";
import LiveStream from "../video/LiveStream";
// import { getSourceId } from './desktopCapture';//uncomment on electron
import VirtualBackground from "../room/virtualBackground";
import PrivacyMode from '../features/privacy-blur/PrivacyMode';
// import { getUser } from "../../renderer/libs/user";//uncomment on electron
import axios from 'axios';
import stringTest from '../components/stringTest';
// import sanitizeHtml from 'sanitize-html';
import LockFocus from '../room/lockFocus';
import KinoTimer from '../room/KinoTimer';
import JoinRequest from '../room/JoinRequest';
import MuteParticipants from "../room/MuteParticipants";
import BottomActions from "../room/BottomActions";
// import { addRecentKino } from "../../renderer/libs/kino/RecentKinos";//uncomment on electron
import KinoLimits from '../room/KinoLimits';
import interact from 'interactjs';
import ScreenShare from '../features/screen-share/ScreenShare';
import UserPreferences from "../room/UserPreferences";
import TimerComponent from "../components/TimerComponent";
import Feedback from "../room/Feedback";
import AnimatedLayers from "../room/AnimatedLayers";
import InviteUser from "../room/InviteUser";
import KinoLobby from '../room/KinoLobby';
import Participants from "../room/participant/Participants";
import Participant from "../room/participant/Participant";
import Volume from "../room/Volume";
import ButtonSpam from "../components/ButtonSpam";
import Session from "../room/Session";
import OnStage from "../features/on-stage/OnStage";
import { disableSimlucastLayers } from "../features/simulcast/Layers";
import Controls from "../features/controls/Controls";
import MuteAllState from "../features/mute-all/MuteAllState";
import Pip from "../features/picture-in-picture/Pip";
import NoiseSuppressionModule from "../features/noise-suppression/NoiseSuppressionModule";
import { getLocalAudioTrack, initBackdropLayer, showBackdropLayer } from "../room/functions";
import { createRnnoiseProcessor } from "../features/rnnoise";
import Permission from "../features/permissions/Permission";
import { addRemoteTrack, getLocalKinoTrack, getLocalTrack, getLocalTracks, remoteCameraMutedWeb, remoteTrackMuteChanged, removeLocalTrack, removeRemoteTrack, setSenderMaxFramerate, storeLocalTrack } from "../features/base/tracks/functions";
import { addTrackEventHandlers } from "../features/base/tracks/events";
import { MEDIA_TYPE } from "../features/base/tracks/constants";
import { updateVideoQuality, videoQualityEventListeners } from "../features/base/video-quality/actions";
import { addPerformanceOptimizerEvents, hidePerformanceMenuItem, loadPerformanceSettingFromStore, showPerformanceMenuItem,showParticipantNumberItem } from "../features/base/performance-optimizer/actions";
import { getCurrentMaxResolution } from "../features/base/video-quality/functions";
import { getPerformanceState, stopCpuStatsCollection } from "../features/base/performance-optimizer/functions";
import { getAccessToken, showSessionClosedModal } from "../features/session-limit/functions";
import NewSpaceView from "../room/spaces/NewSpacesView";
import { addSpacesEventHandlers } from "../features/base/spaces/events";

/* global $, KinoJS */
var isElectron = navigator.userAgent.toLowerCase().indexOf(' electron/') > -1 ? true : false;
var isMac = navigator.userAgent.toLowerCase().indexOf(' mac ') > -1 ? true : false;
var isWindows = navigator.userAgent.toLowerCase().indexOf('windows ') > -1 ? true : false;
var isEdge=navigator.userAgent.toLowerCase().indexOf('edg') > -1 || navigator.userAgent.toLowerCase().indexOf('edge') > -1 ? true : false;
var cameraOptionsPreferences = {
    camera_flip: true
};
let isMobile = window.innerWidth < 920 ? true : false;
let PID = "";
let isReloading=false;
let session=new Session();
//check if was a reload or tab duplicate
console.log("Checking if session in locked",session.isLocked())
if(session.isLocked() || session.getKinoID() != ROOM_NAME){
    console.warn(`Found a locked session to be cleared: locked: ${session.isLocked()} , kino_id: ${session.getKinoID()}`);
    session.clear();
}
//lock the session
session.setKinoID(ROOM_NAME);
session.lock();
let kinoControls = new Controls();
let permissions=new Permission();
let userPreferences = new UserPreferences();
let deviceManager = new DeviceManager();
let vb=new VirtualBackground();
let privacyMode=new PrivacyMode();
let strTest = new stringTest();
let kinoTimer=new KinoTimer();
let lockFocus = new LockFocus();
let joinRequest = new JoinRequest();
let muteAll = new MuteAllState();
let muteParticipants=new MuteParticipants();
let screenShare = new ScreenShare();
let CONV_STORAGE = new Conversations();
let timerComponent = new TimerComponent();
let inviteUser = new InviteUser();
let feedback = new Feedback();
let kinoParticipants = new Participants();
let spacesView = new NewSpaceView();
let kinoLimits = new KinoLimits(PARTICIPANTS_LIMIT,PARTICIPANT_LIMIT_REACHED);
let pictureInPicture=new Pip();
pictureInPicture.buttonEvent();
const noiseSuppression=new NoiseSuppressionModule();
userPreferences.loadAllPreferences();
deviceManager.addEvents();
inviteUser.events();
screenShare.events();
kinoTimer.events();
deviceManager.onSuccess=onLocalTracks;
initBackdropLayer();

//check if we have ad blocker
console.log("Page has adBlocker",isAdBlockActive);
userPreferences.registerFeatureHandler('camera_options',(preferences)=>{
    console.log(`Received camera options preferences ${typeof preferences}`,preferences);
    if(typeof preferences == 'object' && Object.keys(preferences).length > 0){
        cameraOptionsPreferences = preferences;
        onRoomLoadedPreferences();
    }
})
/*Make sure to chek for display name on cookie*/
if (!MY_NAME) {
    let cookieName = isElectron ? localStorage.getItem('displayName') : Cookies.get("displayName");
    console.log("cookie name : " + cookieName);
    if (cookieName) {
        MY_NAME = cookieName;
    } else {
        MY_NAME = "";
    }
    console.log(MY_NAME);
}

let socket = new Socket();
let animatedLayers = new AnimatedLayers();
socket.init();
// socket.addDisconnectBadge();
console.time("kino_joined_event"); //card 798
let connection = null;
window.isConnected = false;
window.initSocketMessage = initSocketMessage;
window.startRoom = startRoom;
let isJoined = false;
let room = null;
let lobby = new KinoLobby();
let onStage = new OnStage();
let Video = new Videos();
const live_stream = new LiveStream();
var chat = null;
Video.init();
spacesView.events();
muteAll.events();
muteParticipants.events();
let volumeManager=new Volume(1);
volumeManager.initMasterVolume();
let localRecording = new LocalRecording(socket, Video);
let bottomAction=new BottomActions();
let buttonSpam = new ButtonSpam();
let localTracks = {};
const remoteTracks = {};
let htmlElements = {};
let audioElements = {};
var permisionTimeout = 0;
let roomInitialized = false;
let conversationTooltipTimeout = 0;
var permisionTimeout = 0;
var countdownInterval;
var BridgeChannelErrors=0;
var BridgeChannelErrorTimeout=0;
//first load all preferences
let sanitizeOptions = {
    allowedTags: [],
    allowedAttributes: {
        span: [],
        img: [],
    },
    allowedSchemesByTag: {
        img: [],
    },
};

//listen for js events
addPerformanceOptimizerEvents();
addTrackEventHandlers();
videoQualityEventListeners();

//Menu buttons added
lobby.renderLobby();

KinoJS.mediaDevices.addEventListener(KinoJS.events.mediaDevices.DEVICE_LIST_CHANGED,onDeviceListChanged);

// Icon variables
let micIcon = `<div class="kinetx-icon"><svg width="400" height="400" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M200.391 265.625C236.714 265.625 266.273 236.181 266.273 200V90.625C266.273 54.4437 236.714 25 200.391 25C164.067 25 134.508 54.4437 134.508 90.625V200C134.508 236.181 164.067 265.625 200.391 265.625Z" fill="white"/>
<path d="M299.215 178.125C293.154 178.125 288.234 183.025 288.234 189.062V200C288.234 248.256 248.836 287.5 200.391 287.5C151.945 287.5 112.547 248.256 112.547 200V189.062C112.547 183.025 107.628 178.125 101.566 178.125C95.5052 178.125 90.5859 183.025 90.5859 189.062V200C90.5859 256.569 134.069 302.681 189.41 308.259V364.062C189.41 370.1 194.329 375 200.391 375C206.452 375 211.371 370.1 211.371 364.062V308.259C266.713 302.681 310.195 256.569 310.195 200V189.062C310.195 183.025 305.276 178.125 299.215 178.125Z" fill="white"/>
</svg>
</div>`;
let micMutedIcon = `<div class="kinetx-icon"><svg width="400" height="400" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M265.403 88.2228C264.31 53.2236 235.217 25.0055 199.999 25.0055C163.906 25.0055 134.375 54.536 134.375 90.6289V200.001C134.375 205.907 135.25 211.376 136.781 216.845L265.403 88.2228Z" fill="#FF3D00"/>
<path d="M199.999 265.625C236.092 265.625 265.622 236.094 265.622 200.001V149.843L371.801 43.6644C376.066 39.3989 376.066 32.4647 371.801 28.1991C367.535 23.9336 360.601 23.9336 356.336 28.1991L28.2183 356.316C23.9309 360.582 23.9309 367.516 28.1964 371.782C32.4619 376.069 39.3743 376.069 43.6617 371.804L131.335 284.131C147.565 297.19 167.253 306.049 189.061 308.28V364.06C189.061 370.185 193.874 374.997 199.999 374.997C206.123 374.997 210.936 370.185 210.936 364.06V308.28C266.06 302.593 309.371 256.656 309.371 200.001V189.064C309.371 182.939 304.559 178.127 298.434 178.127C292.309 178.127 287.497 182.939 287.497 189.064V200.001C287.497 248.344 248.341 287.499 199.999 287.499C179.874 287.499 161.5 280.324 146.603 268.862L162.112 253.353C172.852 260.987 185.977 265.625 199.999 265.625V265.625Z" fill="#FF3D00"/>
<path d="M119.501 234.126C114.907 223.626 112.501 212.032 112.501 200.001V189.064C112.501 182.939 107.688 178.127 101.563 178.127C95.4386 178.127 90.6262 182.939 90.6262 189.064V200.001C90.6262 218.376 95.2199 235.438 103.095 250.531L119.501 234.126Z" fill="#FF3D00"/>
</svg>
</div>`;
let cameraEnabledIcon = `<div class="kinetx-icon"><svg width="400" height="400" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M369.816 113.65C366.622 111.648 362.553 111.45 359.184 113.166L287.5 149.202V123C287.5 104.806 272.778 90 254.688 90H57.8125C39.7219 90 25 104.806 25 123V277C25 295.194 39.7219 310 57.8125 310H254.688C272.778 310 287.5 295.194 287.5 277V250.798L359.163 286.834C362.531 288.528 366.556 288.374 369.794 286.35C373.031 284.348 375 280.806 375 277V123C375 119.194 373.031 115.652 369.816 113.65V113.65Z" fill="white"/></svg></div>`;
let cameraDisabledIcon = `<div class="kinetx-icon"><svg width="400" height="400" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M46.4372 307.202L262.121 91.5075C259.715 90.8513 257.309 90.6325 254.684 90.6325H57.812C39.656 90.6325 25 105.289 25 123.446V276.576C25 290.795 33.9686 302.827 46.4372 307.202Z" fill="#FF3D00"/><path d="M359.245 113.602L287.496 149.478V127.974L371.801 43.6654C376.066 39.3997 376.066 32.4651 371.801 28.1993C367.535 23.9336 360.601 23.9336 356.335 28.1993L28.2156 356.335C23.95 360.6 23.95 367.535 28.2156 371.801C32.4811 376.066 39.4154 376.066 43.6809 371.801L106.089 309.389H254.684C272.84 309.389 287.496 294.733 287.496 276.576V250.544L359.245 286.42C363.292 288.148 367.032 287.689 369.745 285.982C373.026 283.795 374.995 280.295 374.995 276.576V123.446C374.995 119.727 373.026 116.227 369.745 114.04C366.682 112.071 362.526 111.852 359.245 113.602V113.602Z" fill="#FF3D00"/></svg></div>`;
let screenSharingIcon = `<div class="kinetx-icon"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path d="M28 22.688v-16h-24v16h24zM28 4c1.438 0 2.688 1.25 2.688 2.688l-0.063 16c0 1.438-1.188 2.625-2.625 2.625h-6.688v2.688h-10.625v-2.688h-6.688c-1.438 0-2.688-1.188-2.688-2.625v-16c0-1.438 1.25-2.688 2.688-2.688h24z"></path></svg></div>`;
let screenSharingDisableIcon = `<div class="kinetx-icon"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M27.689 22.688V6.688H3.689V22.688H27.689ZM27.689 4C29.127 4 30.377 5.25 30.377 6.688L30.314 22.688C30.314 24.126 29.126 25.313 27.689 25.313H21.001V28.001H10.376V25.313H3.688C2.25 25.313 1 24.125 1 22.688V6.688C1 5.25 2.25 4 3.688 4H27.688H27.689Z" fill="#FAFAFA"/><rect x="12.3" y="11.3" width="7" height="7" fill="#FF3D00"/></svg></div>`;
let flipLocalVideoIcon = `<svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M38.75 54.2502H43.9167V49.0835H38.75V54.2502ZM49.0833 23.2502H54.25V18.0835H49.0833V23.2502ZM7.75 12.9168V49.0835C7.75 51.9252 10.075 54.2502 12.9167 54.2502H23.25V49.0835H12.9167V12.9168H23.25V7.75016H12.9167C10.075 7.75016 7.75 10.0752 7.75 12.9168ZM49.0833 7.75016V12.9168H54.25C54.25 10.0752 51.925 7.75016 49.0833 7.75016ZM28.4167 59.4168H33.5833V2.5835H28.4167V59.4168ZM49.0833 43.9168H54.25V38.7502H49.0833V43.9168ZM38.75 12.9168H43.9167V7.75016H38.75V12.9168ZM49.0833 33.5835H54.25V28.4168H49.0833V33.5835ZM49.0833 54.2502C51.925 54.2502 54.25 51.9252 54.25 49.0835H49.0833V54.2502Z" fill="black"/></svg>`;

var muteMicButton       = $("#room-mute-mic");
var muteCameraButton    = $("#room-mute-video");
var audioDevicesList    = $('#audioDevicesList');
var videoDevicesList    = $("#videoDevicesList");
var screenShareList     = $("#screenShareList");
var roomClose           = $("#room-close");
var showAudioDevices    = $("#showAudioDevices");
var showVideoDevices    = $("#showCameraDevices");
var toggleTileView      = $("#toggleTileView");
// var shareKinoBtn        = $("#share-kino-toggle");
var closeShareKinoBtn   = $('#closeShareMenu');
var optionsBtn          = $('#optionsBtn');
var closeOptionsBtn     = $('#closeOptionsBtn');
var sideMenu            = $('#options-side-menu');
var spacesBtn           = $('#panelToggle');
var startScreenShare    = $("#startScreenShare");
var shareScreenOptions  = $("#showScreenShareOptions");
var sideMenuParticipantBack = $("#sideMenuParticipantBack");
var showKinoMenuDropUp  = $("#showKinoMenuButton")
var kinoIDinMenu = $("#kino-menu-id");
kinoIDinMenu.html(`Kino ID: ${ROOM_NAME}`);

//api call variable
var apiPath
function clearKinoMenu(){
    try {
        hidePerformanceMenuItem();
        vb.removeOptionButton();
        Video.splitConversations.removeOptionButton();
        onStage.removeOptionButton();
        kinoTimer.removeOptionButton();
        Video.announcement.removeOptionButton();
        lockFocus.removeOptionButton();
        kinoControls.onModeratorAccessRemoved();
        $("#option-list").empty();
    } catch (error) {
        console.error('clear kino menu error',error)
        $("#option-list").empty();
    }
}
function renderKinoMenu(){
    showKinoMenuDropUp.dropdown();
    clearKinoMenu();
    //show controls menu
    kinoControls.createControlsMenu();
    //performance optimizer
    showPerformanceMenuItem();
    //show participant number
    showParticipantNumberItem(kinoParticipants.count());
    //mute all
    muteParticipants.addOptionButton();
    //render virtual background option
    try {
        vb.onLoad();
        vb.addOptionButton();
    } catch (error) {
        console.error("Error loading virtual background", error);
    }
    //render privacy mode
    privacyMode.addOptionButton();
    //space manager
    Video.splitConversations.addOptionButton();
    //stage view
    onStage.addOptionButton();
    //kino timer
    try {
        kinoTimer.createTimersContainer();
        kinoTimer.addOptionButton();
        kinoTimer.addModeratorRights();
    } catch (error) {
        console.error("timer error",error)
    }
    //announcer
    Video.announcement.addOptionButton();
    //Spaces lock
    lockFocus.addOptionButton();

    Video.lockMasterVolume.addOptionButton();

    //recorder
    localRecording.addOptionButton();
    //Speaker highlight
    live_stream.addOptionButton();
    Video.speaker.addOptionButton();
    //full screen
    Video.addFullscreenBtn();
    showKinoMenuDropUp.dropdown('update');
}
//electron config
async function electronConfig() {
    let auth = isElectron ?  await getUser() : false;
    return auth ? {headers: {'Authorization': 'Bearer ' + auth.access_token}} : {};
};

function convertPath(path){
    if(isElectron){
        apiPath = `${api.global.app_url}/api${path}`;
        return apiPath;
    }else{
       return path
    }
}

function onRoomLoadedPreferences(){
    console.error('camera preferences ', cameraOptionsPreferences)
    if(cameraOptionsPreferences['camera_flip']!==undefined){
        if(cameraOptionsPreferences['camera_flip'] == true){
            $('#camera-flip-btn').addClass('active')
        }else{
            $('#camera-flip-btn').removeClass('active')
        }
        console.error('camera flip: ',cameraOptionsPreferences.camera_flip);
        if(lobby.localVideoPreview && cameraOptionsPreferences.camera_flip){
            lobby.localVideoPreview.classList.add('flipVideoX');
        }else{
            lobby.localVideoPreview.classList.remove('flipVideoX');
        }
    }
}

if (typeof TUTORIAL_PLAYING == "undefined") {
    var TUTORIAL_PLAYING = false;
}

socket.events.reconnectFailed = function (message) {
    Video.errorMessage(
        "Connection error",
        "Failed to reconnect you to the Kino.",
        "socketError"
    );
    unload('client_network_error');
};
socket.events.throwDisconnectMessage = function (message) {
    Video.errorMessage(
        "Connection error",
        "Failed to reconnect you to the Kino.",
        "socketError"
    );
    unload('client_network_error');
};

socket.events.UserRefreshed=(message)=>{
    //message handler when a user has refreshed
    try {
        Video.splitConversations.onUserRefresh(message.data);
    } catch (error) {
        console.error('UserRefreshed message handler error',error)
    }
};
window.errorMessage = function () {
    if (room) {
        Video.errorMessage(
            "Connection error",
            "Failed to reconnect you to the Kino.",
            "reconnect"
        );
        unload('client_error');
    }
};
window.handleBridgeError=(message)=>{
    console.log("handle bridge error",message);
    try {
        if(message.indexOf("no opened channel") !== -1 || message.indexOf("Channel closed: 1006") !== -1){
            console.log("Got channel error message",BridgeChannelErrors);
            BridgeChannelErrors++;
            if(!BridgeChannelErrorTimeout){
                BridgeChannelErrorTimeout=setTimeout(() => {
                    //if 1 minute passes then clear error counts
                    clearTimeout(BridgeChannelErrorTimeout);
                    BridgeChannelErrors=0;
                }, 60000);
            }
            if(BridgeChannelErrors==10){
                clearTimeout(BridgeChannelErrorTimeout);
                //show error message
                window.errorMessage();
            }
        }else if(message.indexOf("Channel closed: 1001 endpoint closed") !== -1){
            clearTimeout(BridgeChannelErrorTimeout);
            window.errorMessage();
        }
    } catch (error) {
        console.log("message parse error ",error);
    }
};
socket.events.stoppedStreaming = function (data) {
    live_stream.stoppedStreamingEvent(data);
};
socket.events.streamingServices = function (data) {
    live_stream.loadStreamingServices(data);
};
socket.events.UserJoin = function (data) {
    Video.userJoined(data);
    live_stream?.userJoined(data);
    localRecording?.userJoined(data);
};
socket.events.userKicked = function (message) {
    try {
        Video.removeVideo(message.data.participant);
        room.kickParticipant(message.data.participant);
    } catch (error) {
        console.log("userKicked message", error);
    }
};
socket.events.sharingScreen = function (request) {
    let data = request.data;
    Video.presenter.shareScreenEvent(data);
    if(Video.videos[data.participant]){
        Video.videos[data.participant].sharingScreenEvent(data.status);
    }
};
socket.events.hoursLimitReached = function () {
    $("#hours-limit-modal").modal("show");
    $("#videoSpace").remove();
    unload('hours_limit');
    storeLastSpaceId('');
};
socket.events.kinoEndWarning = function (data) {
    // console.log('socked_data', data)
    let icon = `<img src="/images/wave.png" width="30px" height="30px">`;
    let message = `This Kino will end in about ${
        data["ending_minutes"]
    } ${data["ending_minutes"] == 1 ? "minute" : "minutes"}`;
    Video.sounds.play("wave2");
    $("#notificationsBanner").empty();
    Video.showNotification("", message, "");
};

socket.events.connectionSuccess = function () {
  $('body').find('.error-message-overlay').remove();
  try {
      joinRequest.onSocketConnected();
  } catch (error) {}

    $("body").find(".error-message-overlay").remove();
    animatedLayers.removeLocalConnectionLostLayer();
    Video.isDisconnected=false;
};


// document on ready events
$(function() {
    interact('.modal-content').styleCursor(false).draggable({
        ignoreFrom: '.ignore-drag, .split-option-container, .alert, .switch, .btn, .options, input, textarea',
        inertia: true,
        modifiers: [
            interact.modifiers.restrict({
                restriction: '.modal',
                // endOnly: true,
                elementRect: { top: 0, left: 0.9, bottom: 0.1, right: 0.1 }
            }),

        ],
        listeners: {
            // call this function on every dragmove event
            move: dragMoveListener,
            // call this function on every dragend event
            end (event) {
            }
        }
    });

});
function dragMoveListener (event) {
    var target = event.target
    // keep the dragged position in the data-x/data-y attributes
    var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
    var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

    // translate the element
    target.style.transform = 'translate(' + x + 'px, ' + y + 'px)'

    // update the posiion attributes
    target.setAttribute('data-x', x)
    target.setAttribute('data-y', y)
}

function lastUsedCamera() {
    try {
        let camera_id = localStorage.getItem("camera_id");
        if (camera_id) {
            return camera_id;
        } else {
            return false;
        }
    } catch (e) {
        console.log(e.message);
        return false;
    }
}

$("#mobile-menu-toggle").on("click", function () {
    // $('#mobile-menu-toggle').tooltip('hide');
    if ($("#mobileMenu").hasClass("shown")) {
        $("#mobileMenu").addClass("hidden").removeClass("shown");
    } else {
        $("#mobileMenu").addClass("shown").removeClass("hidden");
    }
});

optionsBtn.on('click', function(e){
    e.stopPropagation();
    showSideMenu();
    !permissions.isMod() && $("#options-side-menu").addClass("option-menu-non-moderator")
})
closeOptionsBtn.on('click', function(e){
    e.stopPropagation();
    hideSideMenu();
    !permissions.isMod() && $("#options-side-menu").removeClass("option-menu-non-moderator")
})
try {
    // console.error('offline_event_added')
    Offline.options = {
        requests: false,
        interceptRequests:false
    };
    Offline.on("down", (e) => {
        console.error("Connection state changed to offline", e);
        animatedLayers.reconnectingOverlay();
        Video.isDisconnected=true;
    });
    Offline.on("up", (e) => {
        console.error("Connection state changed to online", e);
        Video.isDisconnected=false;
    });
    Offline.on("up", (e) => {
        console.error("Connection state changed to online", e);
        animatedLayers.removeLocalConnectionLostLayer();
    });
} catch (error) {
    console.error("offline_event_fired", error);
}

function onLocalTracks(tracks) {
    clearTimeout(permisionTimeout);
    deviceManager.clearErrorMessages();
    joinRoom();
    for (let i = 0; i < tracks.length; i++) {
        const track=tracks[i];
        storeLocalTrack(track);
        if (isJoined) {
            room.addTrack(track);
            if(track.getType()=="audio"){
                if(noiseSuppression.isEnabled()){
                    setTimeout(() => {
                        noiseSuppression.enableNoiseSuppression(true);
                    }, 300);
                }
            }
        }
    }
}

function onRemoteTrack(track) {
    if (track.isLocal()) {
        if (track.getType() == "video") {
            console.log("new local video track added");
            try {
                CONV_STORAGE.updateVideoStream(room.myUserId());
            } catch (e) {}
        }
        return;
    }
    const participant = track.getParticipantId();

    if (!remoteTracks[participant]) {
        remoteTracks[participant] = [];
    }
    const idx = remoteTracks[participant].push(track);

    track.addEventListener(
        KinoJS.events.track.TRACK_AUDIO_LEVEL_CHANGED,
        (audioLevel) => console.log(`Audio Level remote: ${audioLevel}`)
    );
    track.addEventListener(KinoJS.events.track.TRACK_MUTE_CHANGED, () =>{
        console.log("remote track mute status changed to ",track.isMuted())
        if(Video.videos[participant] && track.getType() == "video" && !track.isMuted()){
            Video.videos[participant].onVideoUnmuted();
        }
    });
    track.addEventListener(KinoJS.events.track.LOCAL_TRACK_STOPPED, () =>
        console.log("remote track stoped")
    );
    track.addEventListener(KinoJS.events.track.TRACK_VIDEOTYPE_CHANGED,(videoType)=>{
        // console.log("track video type changed",trackChanged)
        if(Video.videos[participant]){
            Video.videos[participant].videoTypeChanged(videoType);
        }
    })
    track.addEventListener(
        KinoJS.events.track.TRACK_AUDIO_OUTPUT_CHANGED,
        (deviceId) =>
            console.log(`track audio output device was changed to ${deviceId}`)
    );
    const id = participant + track.getType() + idx;

    if (track.getType() === "video") {
        //Video.attachVideo(participant, idx, track);
        Video.attachVideoToPlayer(participant, track);
        if (room.getParticipantById(participant).getProperty("video_muted")) {
            Video.cameraMuted(track.getParticipantId(), true);
            CONV_STORAGE.updateVideoStream(participant);
        } else {
            Video.cameraMuted(track.getParticipantId(), track.isMuted());
        }
        //view port event on main screen
        try {
            //Video.efss.updateImediately(true);
        } catch (err) {
            console.error(err);
        }
    } else {
        /*Video.attachAudio(participant, idx, function () {
      track.attach($(`#${id}`)[0]);
    });*/
        // setTimeout(() => {
        //     if(Video && Video.videos[participant]){
        //         Video.videos[participant].skipEfss=false;
        //         if(Video.sideParticipants[participant]){
        //             Video.efss.isInViewPort(Video.videos[participant].viewContainer,$('#sideVideosContainer'),participant);
        //         }else{
        //             Video.efss.isInViewPort(Video.videos[participant].viewContainer,$('#remoteVideos'),participant);
        //         }
        //     }
        // }, 4000);
        Video.attachAudio(participant, track);
        Video.speaker.attachEvent(participant, track.getOriginalStream());
        Video.micMuted(participant, track.isMuted());
        track.attach($(`#${participant}-audio-player`)[0]);
    }
}

async function onConferenceLeft() {
    console.warn("I left this conference bye")
}
/**
 * That function is executed when the conference is joined
 */
async function onConferenceJoined() {
    let timeout;
    console.log("conference joined!");
    displayKinoID();
    PID = room.myUserId();
    try {
        // Video.masterVolumeSlider.val(1);
        Video.checkForGhosts();
    } catch (error) {}
    //end card 744
    PID = room.myUserId();
    if(session.getPID()){
        console.warn(`Found a previous participant ID stored oldPID: ${session.getPID()}, newPID: ${PID}`);
        //send a socket message that pid has changed
        socket.sendUserRefreshed(session.getPID(),PID);
    }
    session.setPID(PID);
    if(session.getResumeRecorder()=="resume"){
        //show resume recording modal
        // localRecording.resumeRecordingModal();
    }
    isJoined = true;
    session.setResumeRecorder('');
    loadPerformanceSettingFromStore();
    // Video.localVideo.viewContainer.attr('id',PID);
    // const rgbaColor = await getRGBAColorFromVideo('localVideo1','0.8');
    // document.getElementById('side-spaces-drawer').style = `background-image: linear-gradient(120deg, ${rgbaColor} 0%, rgba(52, 58, 64,0.8) 100%);`;
    renderKinoMenu();

    if(socket.connected){
        socket.sendRoomPresence({
            user_id: USER_ID,
            guestId: GUEST_ID,
            participant: room.myUserId(),
            displayName: MY_NAME,
            room_id: ROOM_NAME,
            role: ROLE,
            device:'desktop',
            access_id:ACCESS_ID,
            token: getAccessToken()
        });
        if(permissions.canAcceptUsers()){
            socket.moderatorRoom(room.myUserId(),'join')
        }
    }else{
        console.error("Socket was not connected when joined on kino",socket);
        socket.events.setPresece=()=>{
            socket.sendRoomPresence({
                user_id: USER_ID,
                guestId: GUEST_ID,
                participant: room.myUserId(),
                displayName: MY_NAME,
                room_id: ROOM_NAME,
                role: ROLE,
                device:'desktop',
                access_id:ACCESS_ID,
                token: getAccessToken()
            });
            if(permissions.canAcceptUsers()){
                socket.moderatorRoom(room.myUserId(),'join')
            }
        };
    }


    CONV_STORAGE.init();
    addSpacesEventHandlers();
    let selectedSpeaker = deviceManager.lastUsedSpeaker();
    if (selectedSpeaker) {
        deviceManager.changeAudioOutput(selectedSpeaker);
    }
    window.kinoRoom = room;
    window.kino={
        video:Video,
        // socket:socket,
        // timer:kinoTimer
    };
    //begin card 798
    lockFocus.checkLockFocusOnJoin();
    lockFocus.events();
    Video.lockMasterVolume.onUserJoin();
    console.timeEnd("kino_joined_event");
    permissions.applyFeaturePermissions()
    permissions.applySettingsOnJoin();
    // initialize users/participants on entry chat
    console.log("__chat INIT");
    chat.init();

    socket.events.OutOfKino = function (request) {
        let kickeID = request.data.kicked;
        const sessionSwitch=request.data.sessionSwitch;
        console.error("OUT OF KINO MY ID:" + PID + " kicked id:" + kickeID);
        if (kickeID == PID) {
            if(sessionSwitch){
                showSessionClosedModal();
            }else{
                feedback.renderModal();
            }
            unload(sessionSwitch ? 'session_switch' : 'client_kicked');
            storeLastSpaceId('');
        }
    };

    socket.events.FocusSignal = function (request) {
        Video.focusedMe(
            request.data.participantId,
            request.data.autoFocus,
            request.data.silent,
            request.data.space_id ? request.data.space_id : false
        );
    };
    socket.events.unFocusSignal = function (request) {
        Video.unFocusedMe(request.data.participantId);
    };

    if(kinoControls.showMenuButtonCont){
        kinoControls.showMenuButtonCont.removeClass('d-none');
    }
    getLocalTracks().forEach(track=>{
        if(track.type == MEDIA_TYPE.AUDIO){
            console.log(`Mute on join check last_space:${CONV_STORAGE.getLastSpaceId()},mic muted:${track.muted}`);
            if(permissions.shouldMuteMicrophone()){
                track.kinoTrack.mute();
            }else{
                if(!CONV_STORAGE.getLastSpaceId() && !track.muted){
                    muteAll.checkMuteAllPolicy(()=>{
                        track.kinoTrack.mute();
                        Video.showNotification('',`Microphones have been muted by the moderators`,'mute_all','');
                    });
                }
            }
        }else if(track.type == MEDIA_TYPE.VIDEO){
            if(!track.muted){
                Video.cameraMuted(room.myUserId(), false);
            }
        }
        room.addTrack(track.kinoTrack);
    })


    setTimeout(() => {
        if(noiseSuppression.isEnabled()){
            noiseSuppression.enableNoiseSuppression(true);
        }
        //verify muted tracks
        if(!room.getLocalAudioTrack() || (room.getLocalAudioTrack() && room.getLocalAudioTrack().isMuted())){
                muteMicButton.html(micMutedIcon);
                Video.micMuted(room.myUserId(),true);
        }
        const videoTrack=getLocalKinoTrack(MEDIA_TYPE.VIDEO);
        if(!videoTrack || (videoTrack && videoTrack.isMuted())){
            muteCameraButton.attr('data-original-title', 'Camera Off');
            muteCameraButton.attr('title', 'Camera Off');
            muteCameraButton.html(cameraDisabledIcon);
            Video.cameraMuted("local",true);
            room.setLocalParticipantProperty('video_muted', true);
        }
    }, 300);

    room.setSenderVideoConstraint(getCurrentMaxResolution());
    const {maxFrameRate} = getPerformanceState();
    setSenderMaxFramerate(maxFrameRate);
    try{
        activateButtons();
        DeviceListSettings();
        timeout = setTimeout(() => {
            lobby.removeJoiningTheKinoOverlay();
            clearTimeout(timeout)
        }, 2000);
    }catch(e){
        console.error(e.message);
    }
}


function activateButtons(){
    Video.toolBox.removeClass('d-none');
    roomClose.removeAttr("disabled");
    muteMicButton.removeAttr("disabled");
    muteCameraButton.removeAttr("disabled");
    showAudioDevices.removeAttr("disabled");
    showVideoDevices.removeAttr("disabled");
    toggleTileView.removeAttr("disabled");
    inviteUser.shareKinoBtn.removeAttr("disabled");
    optionsBtn.removeAttr("disabled");
    spacesBtn.removeAttr("disabled");
    startScreenShare.removeAttr("disabled");
    shareScreenOptions.removeAttr("disabled");
}

/**
 *
 * @param id
 */
function onUserLeft(id) {
    console.log("user left kino:" + id);
    console.log("my id is",PID);
    // console.log("Am I joined",room.isJoined());
    $(`#pullFocusParticipant option[value=${id}]`).remove();
    try {
        if(id!=PID){
           Video.removeVideo(id);
        }
        if(!room.isJoined() && Video && !room.myUserId() && isJoined){
            console.error("I dropped from kino");
            isJoined=false;
            onConnectionFailed('unstable');
            if(Video){
                unload('client_drop');
            }
        }
    } catch (e) {}
    if (isJoined) {
        setTimeout(() => {
            socket.sendStreamDrop(id);
        }, 5000);
    }
    if (!remoteTracks[id]) {
        return;
    }
    const tracks = remoteTracks[id];

    for (let i = 0; i < tracks.length; i++) {
        tracks[i].detach($(`#${id}${tracks[i].getType()}`));
    }
}

function getKinoRole(){
    if(permissions.isWorkspace){
        return permissions.getRole()?.name || "member"
    }

    if(HOST == 1){
        return "host"
    }else if(ROLE=="moderator"){
        return "moderator"
    }else if(IS_MEMBER){
        return "member"
    }else{
        return 'guest'
    }
}
/**
 * That function is called when connection is established successfully
 */
async function onConnectionSuccess() {
    //fix name not updated locally
    if (typeof Video !== "undefined") {
        if (Video.localVideo) {
            Video.localVideo.nameContainer.html(`<span>${MY_NAME} (me)</span>`);
        }
    }
    if (room !== null) {
        // console.log(room);
        return;
    }
    lobby.lobby.remove();
    setCodecBasedOnCPU();
    // console.log('noise proccessor',createRnnoiseProcessor);
    if(confOptions.enableNoisyMicDetection){
        confOptions.createVADProcessor = createRnnoiseProcessor;
        console.log("enabling noisy microphone detection");
    }
    const asigned_space=permissions.initialSpace() ? permissions.initialSpace() : CONV_STORAGE.getLastSpaceId();
    if(asigned_space){
        connection.addFeature('assigned_space:'+asigned_space);
    }
    room = connection.initKinoConference(ROOM_NAME, confOptions);
    chat = new Chat();
    room.setDisplayName(MY_NAME);
    console.log("My user id ",room.myUserId());

    kinoParticipants.addParticipant(new Participant(room.myUserId(),MY_NAME,true));
    room.setLocalParticipantProperty("guest_id", GUEST_ID);
    //pull focus
    room.setLocalParticipantProperty("role", getKinoRole());
    room.setLocalParticipantProperty("user_id",USER_ID);
    room.setLocalParticipantProperty("member",IS_MEMBER);
    room.setLocalParticipantProperty("email", USER_EMAIL ? USER_EMAIL : localStorage.getItem("displayEmail"))
    room.room.role = ROLE;

    CONV_STORAGE.prepareSpaces(ROOM_NAME);

    room.on(KinoJS.events.conference.TRACK_ADDED, addRemoteTrack);
    room.on(KinoJS.events.conference.TRACK_REMOVED, (track) => {
        console.log(`track removed!!!${track}`);
        try {
            Video && Video.removeTrack(track.getParticipantId(), track);
            if(track.isLocal()){
                removeLocalTrack(track);
            }else{
                removeRemoteTrack(track);
            }
            // if (track.getType() == "video") {
            //     Video.removeVideo(track.userID, true);
            // }
        } catch (error) {
            console.error(`Remove track error`,error)
        }

    });

    room.on(KinoJS.events.conference.TRACK_VIDEOTYPE_CHANGED, (track) => {
        console.log(`track video type changed!!!${track}`);
    });
    //room.setReceiverVideoConstraint(constraints);
    room.on(KinoJS.events.conference.CONFERENCE_JOINED, onConferenceJoined);
    room.on(KinoJS.events.conference.CONFERENCE_LEFT, onConferenceLeft);
    room.on(KinoJS.events.conference.USER_JOINED, async (id, user) => {

        console.log(
            "[USER_JOINED]: " + id + " has assigned space: " ,user.hasFeature('assigned_space')
        );
        remoteTracks[id] = [];
        Video.addVideo(id, user.getDisplayName());
        // Video.onParticipantJoined(user);

        if ($("#splitToConvo").hasClass("show")) {
            if ($("#pills-manual-tab").hasClass("active")) {
                Video.splitConversations.modalRenderParticipantsSection();
            } else {
                Video.splitConversations.showNumberOfParticipants();
            }
        }

        // check if room is already initialized and ignore
        if (!roomInitialized) {
            axios.post(convertPath(`/room/init/${ROOM_NAME}`),{}, await electronConfig())
                .then((res) => {
                    // console.log("ROOM_INIT");
                    roomInitialized = true;
                })
                .catch((err) => {
                    // console.log("ROOM_INIT_2");
                    roomInitialized = true;
                });
        }
    });
    room.on(KinoJS.events.conference.DATA_CHANNEL_OPENED, () => {

        room.setLocalParticipantProperty("connected", true);
        if(Video){
            setTimeout(() => {
                updateVideoQuality();
            }, 1000);
        }

        // //bamirs
        // chat.reloadMessages();
        console.warn("CHAT DATA CHANNEL OPENED");
  });
  room.on(KinoJS.events.conference.ENDPOINT_CONN_STATUS_CHANGED,((pid,status)=>{
    console.log(`[EVENT] Endpoint status changed ${pid} status `,status);
  }))
  room.on(KinoJS.events.conference.USER_LEFT, onUserLeft);
  room.on(KinoJS.events.conference.TRACK_MUTE_CHANGED, (track) => {
    console.log(`Track mute state changed ${track.getType()} - ${track.isMuted()}`);
    remoteTrackMuteChanged(track);
    // if (track.getType() == "audio") {
    //   console.log(
    //     "Participant audio track mute changed to :" + track.isMuted()
    //   );
    //   if (track.isMuted()) {
    //     Video.speaker.removeSpeaker(track.getParticipantId());
    //   }
    //   Video.micMuted(track.getParticipantId(), track.isMuted());
    // } else {
    //   Video.cameraMuted(track.getParticipantId(), track.isMuted());
    // }
  });
  room.on(KinoJS.events.USER_ROLE_CHANGED, (id, role) => {
    console.log('user with id:' + id + ' has ' + role + ' role.');
  });

  room.on(
      KinoJS.events.conference.DISPLAY_NAME_CHANGED, (userId, displayName) => {
          chat.nameChanged(userId, displayName);
          Video.onNameChanged(userId, displayName)
          live_stream.onNameChanged(userId, displayName)
          localRecording.onNameChanged(userId, displayName)
      }
  );

  room.on(KinoJS.events.conference.ENDPOINT_MESSAGE_RECEIVED, (user, message) => {
    chat.endpointMessageReceived(user, message)
    live_stream.endpointMessageReceived(user, message)
    // if(message.lock_focus_message){
    //     lockFocus.handleLockFocusMessage(user,message);
    //     return;
    // }
    if(message.recent_split){
        Video.splitConversations.onRecentSplitEvent(user,message);
        return;
    }
    // if(message.release_focus){
    //     Video.stealFocus.releaseFocusEvent(user,message);
    // }
    // if(message.mute_mic){
    //     muteParticipants.muteEvent(user,message);
    // }
    if(message.timer_message){
        kinoTimer.timerMessageHandle(message, user);
    }
    if(message.is_joining_space_message){
        CONV_STORAGE.userJoiningSpaceHandler(message, user);
    }
    if(message.notify_other_participants_message){
        CONV_STORAGE.notifyOtherParticipantsHandler(message, user);
    }
    try {
        if(message && message.message && message.message == "announcement_started") {
            Video.announcement.isAnnouncingMsg(user)
        }
        if(message && message.message == 'accepted_or_rejected_private_space'){
            CONV_STORAGE.userJoiningPrivateSpaceHandler(message, user);
        }
        if(message && message.message == 'remove_join_layer'){
            CONV_STORAGE.removeJoiningLayerHandler(message);
        }
    } catch (error) {
        console.error('anonc', error)
    }
  });
  room.on(
    KinoJS.events.conference.TRACK_AUDIO_LEVEL_CHANGED,
    (userID, audioLevel) => console.log(`${userID} - ${audioLevel}`)
  );
  room.on(KinoJS.events.conference.PHONE_NUMBER_CHANGED, () =>
    console.log(`${room.getPhoneNumber()} - ${room.getPhonePin()}`)
  );

  room.on(KinoJS.events.connectionQuality.REMOTE_STATS_UPDATED, (id, stats) => {
    Video.connectionQuality(id, stats);
  });
  room.on(KinoJS.events.connectionQuality.LOCAL_STATS_UPDATED, (stats) => {
    Video.connectionQuality('local', stats);
  });

  room.on(KinoJS.events.conference.PARTICIPANT_PROPERTY_CHANGED,(user,propertyKey,oldValue,newValue) => {
    console.log(`User ${user.getId()} property ${propertyKey} changed from:${oldValue} to:${newValue}`);
      //pull focus list update
            if(propertyKey=="role"){
                Video.userRoleChanged(user.getId(),newValue);
                onStage.listKinoParticipants();
            } else if(propertyKey=="connected"){
                if(chat) chat.userConnected(user)
                if(kinoTimer) kinoTimer.userConnected(user);
                // card 214
                try {
                    if(Video.announcement.announcing) {
                        room.sendEndpointMessage(user.getId(), {
                            sender: room.myUserId(),
                            message: 'announcement_started'
                        })
                    }
                } catch (error) {
                    console.error('anonc', error)
                }
            // end card 214
            } else if(propertyKey=="guest_id"){
                if(chat){
                    chat.guestIdPropertyChanged(user)
                    if($('#chat-content-container').find('.select-user-list').hasClass('active') ){
                        chat.showParticpantsToChat();
                    }
                }
            }else if(propertyKey=="video_muted"){
                // Video.cameraMuted(user.getId(),newValue ? true :false);
                remoteCameraMutedWeb(user,newValue ? true :false)
            } else if(propertyKey == "kino_recording_status") {
                // console.log("property_changed", localRecording)
                localRecording?.recordingStatusChanged(user, newValue)
                // console.log("property_changed")
            }else if(propertyKey == "recent_space"){
                Video.splitConversations.onUserRecentSpaceChanged(user.getId(),newValue);
            }else if(propertyKey == "sharing_screen"){
                Video.videos[user.getId()].sharingScreenEvent(newValue ? "started" : "stopped");
                Video.presenter.shareScreenEvent({
                    participant:user.getId(),
                    status:newValue ? "started" : "stopped"
                });
            }else if(propertyKey == "mute_all_policy"){
                muteAll.onMuteStateChanged(user,newValue);
            }else if(propertyKey == "email"){
                Video.userEmailChanged(user.getId(),newValue)
            }

    });

    room.on(
        KinoJS.events.conference.NOISY_MIC,
        () => {
            if(!noiseSuppression.isActive()){
                noiseSuppression.showNoiseSuppressionTooltip();
            }
            console.error(`Noisy mic detected`)}
      );

    room.on(
        KinoJS.events.conference.TRACK_AUDIO_LEVEL_CHANGED,
        (userID, audioLevel) => console.log(`${userID} - ${audioLevel}`)
    );
    room.on(KinoJS.events.conference.PHONE_NUMBER_CHANGED, () =>
        console.log(`${room.getPhoneNumber()} - ${room.getPhonePin()}`)
    );

    room.on(
        KinoJS.events.connectionQuality.REMOTE_STATS_UPDATED,
        (id, stats) => {
            Video.connectionQuality(id, stats);
        }
    );
    room.on(KinoJS.events.connectionQuality.LOCAL_STATS_UPDATED, (stats) => {
        Video.connectionQuality("local", stats);
    });
    room.on(KinoJS.events.conference.CONFERENCE_ERROR, onErrorMessage);
    room.on(KinoJS.events.conference.CONFERENCE_FAILED, onErrorMessage);

    room.on(KinoJS.errors.conference.SETUP_FAILED, ()=>{
        console.error("SETUP_FAILED")
    });
    room.on(KinoJS.errors.conference.JINGLE_FATAL_ERROR, ()=>{
        console.error("JINGLE_FATAL_ERROR ")
    });
    room.on(KinoJS.errors.conference.FOCUS_DISCONNECTED, ()=>{
        console.error("FOCUS_DISCONNECTED  ")
    });
    room.on(KinoJS.errors.connection.OTHER_ERROR, ()=>{
        console.error("OTHER_ERROR   ")
    });
    room.on(KinoJS.errors.connection.CONNECTION_DROPPED_ERROR , ()=>{
        console.error("OTHER_ERROR   ")
    });

    try {
        //room.setSenderVideoConstraint(720);
    } catch (e) {
        console.error(e.message);
    }
    // window.onerror = function(message, source, lineno, colno, error) {
    //     console.error("A global error:",error.message);

    // };
    room.join();
}

/**
 * This function is called when the connection fail.
 */
function onConnectionFailed(errortype="reconnect") {
    try {
        console.error("Connection Failed!");
        Video.errorMessage(
            "Something went wrong",
            errortype == "unstable" ? "Connection to the kino is not stable or slow" : "We're trying to reconnect you back to the Kino",
            errortype
        );
    } catch (error) {

    }

}

function onErrorMessage(err) {
    Video.errorMessage(
        "Something went wrong",
        "We're trying to reconnect you back to the Kino"
    );
}
/**
 * This function is called when the connection fail.
 */
function onDeviceListChanged(devices) {
    console.info("current devices", devices);
    lobby.updateDeviceList();
}

/**
 * This function is called when we disconnect.
 */
function disconnect() {
    console.log("disconnect!");
    if (connection == null) {
        return;
    }
    connection.removeEventListener(
        KinoJS.events.connection.CONNECTION_ESTABLISHED,
        onConnectionSuccess
    );
    connection.removeEventListener(
        KinoJS.events.connection.CONNECTION_FAILED,
        onConnectionFailed
    );
    connection.removeEventListener(
        KinoJS.events.connection.CONNECTION_DISCONNECTED,
        disconnect
    );
}

/**
 *
 */

  function unload(reason='client_hangup') {
     try{
      console.log("UNLOAD:",reason)
      isJoined=false;
      if(reason === 'client_reload'){
        lobby.showConnectingScreen();
        if(CONV_STORAGE.myConversation){
            CONV_STORAGE.storeLastSpaceId(CONV_STORAGE.myConversation,CONV_STORAGE.isPrivate(CONV_STORAGE.myConversation));
        }
      }
      try {
        live_stream && live_stream.unload();
      } catch (error) {

      }
      if(!isReloading){
        showBackdropLayer();
      }

      if(localRecording?.isRecording){
        localRecording.stopCapture(true);
        live_stream.unload();
      }

      try {
        if(pictureInPicture.isPIP()){
            pictureInPicture.stop();
        }
      } catch (error) {

      }
    //  Uncomment on electron
    //   if(isElectron){
    //     stopCpuStatsCollection();
    //   }
      if(socket){
            console.log("Terminate socket connection")
            socket.sendTerminateSession(reason)
        }
      try {
        inviteUser.unloadModals();
        $('#notifications').remove();
        joinRequest.stopTimeUpdater();
        screenShare.popup.closePopup();
        chat.mainChat.closeChatPopup();
        if(kinoTimer.activeTimers){
            kinoTimer.closeAndStopTimer(true);
        }
        if(spacesView.isOpen()){spacesView.hideSpaceView()}
        if(kinoTimer.modal)kinoTimer.modal.remove();
        if(Video.splitConversations.modal)Video.splitConversations.modal.remove();
        if(vb.modal)vb.modal.remove();
        if(onStage)onStage.hideOnStageModal();
        if(onStage && onStage.micMutedModal) onStage.removeModal(onStage.micMutedModal);
        if(kinoControls.hideControlsMenu());
        Video.minimizedContent.removeModeratorAccess(true);
      } catch (error) {

      }

      $.each(localTracks, function(i, track) {
        localTracks[i].getTrack().stop();
          localTracks[i].dispose();
      });
        if(Video){
           Video.stopPresenter();
        }
        try {
            vb.unload();
            if(screenShare.isSharing()){
                screenShare.mutedWhileSharingScreen=true;
                screenShare.onScreenShareStop();
            }
        } catch (error) {}
        try {
            room.getLocalTracks().forEach((track) => {
                if (track._originalStream) {
                    track._originalStream.stop();
                }
                track.dispose();
                track.getTrack().stop();
            });
            room.getLocalTracks().forEach(track=>{
                room.removeTrack(track);
            });
        } catch (err) {
            console.log("error removing local tracks", err);
        }

        isJoined = false;
        try {
            room.leave();
            connection.disconnect();
        } catch (error) {}
        $("#videoSpace").remove();

        socket && socket.close();
        clearTimeout(socket.throwErrorTimeout);
        clearTimeout(socket.retryTimeout);
        room = null;
        connection = null;
        socket = null;
        CONV_STORAGE = null;
        Video = null;

        if (document.cancelFullScreen) {
            document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
    } catch (e) {
        console.log("Erro on unload", e);
    }
}

let isVideo = true;
let screenShareTracks = [];
/**
 *
 * @param selected
 */
function changeAudioOutput(selected) {
    // eslint-disable-line no-unused-vars
    KinoJS.mediaDevices.setAudioOutputDevice(selected.value);
}

$(window).bind("beforeunload",()=>{
    console.log("On before unload");
    isReloading=true;
    session.unlock();
    if(localRecording?.isRecording){
        session.setResumeRecorder('resume');
    }
    unload('client_reload');
});
$(window).bind("unload", ()=>{
    unload('client_reload')
});

window.addEventListener('blur',()=>{
    screenShare.popup.focusWindow();
});

document.addEventListener("visibilitychange", function() {
    if (document.visibilityState != 'visible' && !isElectron) {
        console.log('lost focus');
        setTimeout(() => {
            screenShare.popup.focusWindow();
        }, 1000);
    } else {
        // console.log('lost focus');
    }
});
// function requestAccessAgain(){
//   let msgContainer = $('#name-messageLabel')
//   let enteredName = $('#join-display-name').val();
//   enteredName = sanitizeHtml(enteredName, sanitizeOptions);
//   enteredName = enteredName.trim();
// //   let regTest = strTest.enterNameModal(enteredName, 'name')

//   if (enteredName.length < 2) {
//     $('#join-display-name').val(enteredName)
//     msgContainer.html('Please enter a name with a minimum of 2 characters');
//     return;
//   }
// //   if(regTest){
// //       msgContainer.html(regTest);
// //       return;
// //   }

//   disableJoinButton('join-kino-btn');
//   $('#display-name-modal').modal('hide');
//   MY_NAME = enteredName;
//   Cookies.set('displayName', enteredName, {
//       expires: 365
//   });
//   Video.localVideo.nameContainer.html($('<span />', {
//       text: MY_NAME
//   }));

//   msgContainer.html('')
//   initSocketMessage();
//   startRoom();
// }


function initSocketMessage(){
  joinRequest.addSocketEvents();
}

function joinRoom(){
    /**join room */
    if (connection) {
        return;
    }

    if(isElectron){
        //fix options bosh protocol
        options.bosh="https:"+options.bosh;
        console.log('modifying options',options);
    }
    connection = new KinoJS.KinoConnection(null, null, options);
    window.isConnected = true;
    KinoJS.setLogLevel(KinoJS.logLevels.ERROR);

    connection.addEventListener(
        KinoJS.events.connection.CONNECTION_ESTABLISHED,
        onConnectionSuccess
    );
    connection.addEventListener(
        KinoJS.events.connection.CONNECTION_FAILED,
        onConnectionFailed
    );
    connection.addEventListener(
        KinoJS.events.connection.CONNECTION_DISCONNECTED,
        disconnect
    );
    connection.connect();

    /*join room */
}

function startRoom() {
    stopMediaPlayers($("#tutorial-app .videos"));
    $("#tutorial-app").remove();
    //show allow camera modal here
    // permisionTimeout = setTimeout(function () {
    //     deviceManager.requestPermissionMessage();
    // }, 700);

    // deviceManager.initRoom();

    if (HOST && permissions.hasInvite()) {
        $("#inviteTooltip").css("display", "flex");
        setTimeout(() => {
            $("#inviteTooltip").css("opacity", "1");
            //remove after 10 sec
            setTimeout(() => {
                $("#inviteTooltip").css("opacity", "0");
                setTimeout(() => {
                    $("#inviteTooltip").css("display", "none");
                }, 1000);
            }, 10000);
        }, 3000);

        $(".invite-btn").click(function () {
            $("#inviteTooltip").css("display", "none");
        });
        $("#inviteToolTipExitButton").click(function () {
            $("#inviteTooltip").css("display", "none");
        });
    }

    conversationTooltipTimeout = setTimeout(() => {
        if (
            room &&
            room.getParticipants().length &&
            $("#join-conv-tooltip")
        ) {
            $("#join-conv-tooltip").addClass("d-flex");

            setTimeout(() => {
                $("#join-conv-tooltip").css("opacity", "1");
            }, 1000);
        }

        setTimeout(() => {
            clearTimeout(conversationTooltipTimeout);
            $("#join-conv-tooltip").css("opacity", "0");

            setTimeout(() => {
                $("#join-conv-tooltip").remove();
            }, 1000);
        }, 5000);
    }, 5000);
}

muteMicButton.on("click", function (e) {
    toggleMic();
});
function toggleMic(){
    if(buttonSpam.isSpam('room-mute-mic',true,600)){
        return
    }
    if (room.getLocalAudioTrack() !== undefined) {
        if (!room.getLocalAudioTrack().isMuted()) {
            //mute
            muteMic();
        } else {
            //unmute
            if(!muteAll.isUnmuteAllowed()){
                muteAll.showMuteLockedTooltip();
            }else{
                unMuteMic();
                muteAll.hideTooltip();
            }
            //localTracks["audio"].stream.getAudioTracks()[0].enabled = true;
        }
    }
    DeviceListSettings();
}
function isMicMuted(){
    if(room && room.getLocalAudioTrack() && !room.getLocalAudioTrack().isMuted()){
        return false;
    }
    return true;
}

function muteMic(){
    try {
        room.getLocalAudioTrack().mute();
        // muteMicButton.attr('data-original-title', 'Mic Off');
        // muteMicButton.attr('title', 'Mic Off');
        muteMicButton.html(micMutedIcon);
        pictureInPicture.setMicrophoneActive(false);
    } catch (e) {
        console.log("Can not mute audio");
    }
}

function unMuteMic(){
    try {
        room.getLocalAudioTrack().unmute();
        // muteMicButton.attr('data-original-title', 'Mic On');
        // muteMicButton.attr('title', 'Mic On');
        muteMicButton.html(micIcon);
        pictureInPicture.setMicrophoneActive(false);
    } catch (e) {
        console.log("Can not mute audio");
    }
}

muteCameraButton.on("click", function (e) {
    toggleCamera();
});

function toggleCamera(){
    if(buttonSpam.isSpam('room-mute-video',true,1000)){
        return
    }
    // if (screenShare.isSharing()) {
    //     try {
    //         if (deviceManager.mutedWhileSharingScreen) {
    //           screenShare.unMuteLocalVideo();
    //         } else {
    //           screenShare.muteLocalVideo();
    //         }
    //     } catch (error) {}
    //     DeviceListSettings();
    //     return;
    // } else if (deviceManager.mutedWhileSharingScreen) {
    //     //unmute
    //     unMuteCamera(true);
    //     return;
    // }
    const videoTrack=getLocalKinoTrack(MEDIA_TYPE.VIDEO)

    if (videoTrack !== undefined) {
        if (!videoTrack.isMuted()) {
            //mute
            muteCamera();
        } else {
            //unmute
            unMuteCamera();
        }
    } else {
        console.log("video track is undefined");
    }
}
function isCameraMuted(){
    // if (screenShare.isSharing()) {
    //     if(screenShare.cameraStream){
    //         return false;
    //     }
    //     return true;
    // }
    const videoTrack=getLocalKinoTrack(MEDIA_TYPE.VIDEO)
    if(room && videoTrack && !videoTrack.isMuted()){
        return false;
    }
    return true;
};

function muteCamera(){
    deviceManager.muteVideo().then((muted) => {
        // muteCameraButton.attr("data-original-title", "Camera Off");
        // muteCameraButton.attr("title", "Camera Off");
        muteCameraButton.html(cameraDisabledIcon);
        pictureInPicture.setCameraActive(false)
        DeviceListSettings();
    }).catch((error) => console.error(error));
}

function unMuteCamera(screenSharing = false){
    deviceManager.unMuteVideo().then((unmuted) => {
        // muteCameraButton.attr("data-original-title", "Camera On");
        // muteCameraButton.attr("title", "Camera On");
        muteCameraButton.html(cameraEnabledIcon);
        pictureInPicture.setCameraActive(true);
        setTimeout(() => {
            DeviceListSettings();
        }, 200);
        if(screenSharing)deviceManager.mutedWhileSharingScreen = false;
    }).catch((error) => console.error(error));
}

roomClose.on("click", function (e) {
    unload('client_hangup');
    feedback.renderModal();
    storeLastSpaceId('');
});

function DeviceListSettings() {
    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        console.log("enumerateDevices() not supported.");
    }
    // console.trace("called get device list");
    let cameraListContainer=$("<div/>",{
        class:"camera-list-container-scrollable"
    });
    let audioListContainer=$("<div/>",{
        class:"audio-list-container-scrollable"
    });

    // List cameras and microphones.
    KinoJS.mediaDevices.enumerateDevices((devices) => {
        audioDevicesList.html(audioListContainer);
        videoDevicesList.html(cameraListContainer);
        // console.trace('DEVICES ', devices);
        cameraListContainer.html(
            `<h6 class="dropdown-header px-2">Camera devices</h6>`
        );
        audioListContainer.html(
            `<h6 class="dropdown-header px-2">Microphone devices</h6>`
        );
        let selected = "";
        let selectedAudioDevice = "";
        let selectedVideoDevice = "";
        let selectedSpeaker = deviceManager.lastUsedSpeaker();
        let outputDevices = [];
        if (room) {
            selectedAudioDevice =
                room.getLocalAudioTrack() !== undefined
                    ? room.getLocalAudioTrack().deviceId
                    : "";
            const videoTrack=getLocalKinoTrack(MEDIA_TYPE.VIDEO)
            if(videoTrack !== undefined){
                if(screenShare.isSharing()){
                    if(screenShare.cameraStream){
                        selectedVideoDevice=screenShare.cameraStream.deviceId;
                    }else{
                        selectedVideoDevice=deviceManager.lastUsedCamera();
                    }
                }else{
                    selectedVideoDevice=videoTrack.deviceId;
                }
            }
        }

        devices.forEach(function (device) {
            // console.log(device);
            selected = "";
            //let option = `<option value="${device.deviceId}">${device.label}</option>\n`;

            if (device.kind == "videoinput") {
                if (device.label == "") {
                    device.label = device.deviceId;
                }

                if (selectedVideoDevice == device.deviceId) {
                    selected = "selected";
                }
                let option = `<a class="dropdown-item video-input-device ${selected}" href="#" device-id="${device.deviceId}" >
                    <i class="fas fa-video mr-1"></i>
                        <span class="ellipsis">${device.label}</span>
                    </a>`;
                    cameraListContainer.append(option);
            } else if (device.kind == "audioinput") {
                if (device.label == "") {
                    device.label = device.deviceId;
                }
                if (selectedAudioDevice == device.deviceId) {
                    selected = "selected";
                }
                let option = `<a class="dropdown-item audio-input-device ${selected}" href="#" device-id="${device.deviceId}" >
                    <i class="fas fa-microphone mr-1"></i>
                        <span class="ellipsis">${device.label}</span>
                    </a>`;
                    audioListContainer.append(option);
            } else if (device.kind == "audiooutput") {
                outputDevices.push(
                    $("<a/>", {
                        class: `dropdown-item audio-output-device ${
                            selectedSpeaker == device.deviceId
                                ? "selected"
                                : !selectedSpeaker &&
                                  device.deviceId == "communications"
                                ? "selected"
                                : ""
                        }`,
                        href: "#",
                        "device-id": device.deviceId,
                        html: ['<i class="fas fa-volume-up mr-1"></i> ','<span class="ellipsis">'+device.label+'</span>'],
                    }).on(
                        "click",()=>{
                            audioOptionClicked=true;
                            setTimeout(() => {
                                audioOptionClicked=false;
                            }, 200);
                            deviceManager.changeAudioOutput(device.deviceId)

                        }
                    )
                );
            }
        });
        audioListContainer.append(
            `<h6 class="dropdown-header px-2 mt-3">Speaker devices</h6>`
        );
        audioListContainer.append(outputDevices);
        audioDevicesList.append(
            `<h6 class="dropdown-header px-2 mt-3">Audio settings</h6>`
        );
        //mic options
        // audioDevicesList.append(
        //     `<h6 class="dropdown-header px-2 mt-3"></h6>`
        // );

        let toggleNoiseSuppression = $('<input/>',{
            type: 'checkbox',
            id:`toggleNoiseSuppression`,
            checked: noiseSuppression.isActive()
        }).on('change', function(e){
            e.stopPropagation();
            if($(this).is(':checked')){
                if(noiseSuppression.enableNoiseSuppression(false)){
                    $(this).prop('checked', false)
                }
            }else{
                if(noiseSuppression.enableNoiseSuppression(true)){
                    $(this).prop('checked', true)
                }
            }
            console.log('Noise suppression ', $(this).is(':checked'))
        })

        let toggleNoiseSuppressionInput = $('<label/>',{
            class: 'switch pe-none',
            html: [toggleNoiseSuppression, `<span class="kino-slider round"></span>`]
        })

        let toggleNoiseSuppressionIcon = $('<span/>',{
            class: 'd-flex camera-settings-text-container',
            html: [noiseSuppression.icon, '&nbsp;Noise Suppression']
        })

        let toggleNoiseSuppressionContainer=$('<div/>',{
            class: `d-flex dropdown-item no-hover justify-content-between align-items-center cursor-pointer kino-toggle ${!noiseSuppression.canEnableNoiseSuppression(getLocalAudioTrack()) ? 'button-disabled' : ''}`,
            id: 'toggleNoiseSuppressionContainer',
            html: [toggleNoiseSuppressionIcon, toggleNoiseSuppressionInput]
        }).on('click', function(e){
            e.stopPropagation();
            toggleNoiseSuppression.trigger('change')
        })
        audioDevicesList.append(toggleNoiseSuppressionContainer);
        let micMuted=isMicMuted();
        audioDevicesList.append($("<div/>", {
            class: `dropdown-item audio-input-device dropdown-action ${micMuted ? '' : 'action-mute'}`,
            html: [``,`<span class="ellipsis">${micMuted ? 'Unmute' : 'Mute'} microphone</span>`],
        }).on("click",(e)=>{
            e.preventDefault();
            e.stopPropagation();
            toggleMic();
        }));



        let flipLocalVideoInput = $('<input/>',{
            type: 'checkbox',
            id:`flipCameraControlOption`,
            checked: cameraOptionsPreferences.camera_flip ? true : false
        }).on('change', function(e){
            e.stopPropagation();
            if($(this).is(':checked')){
                $(this).prop('checked', false)
                Video.unFlipLocalVideo();
                setCameraOptionsPreferences({camera_flip: false})
            }else{
                $(this).prop('checked', true)
                Video.flipLocalVideo();
                setCameraOptionsPreferences({camera_flip: true})
            }
            updateFlippedVideos()
            console.log('Hello ', $(this).is(':checked'))
        })
        let flipLocalVideoSwitch = $('<span/>',{
            class: 'kino-slider round',
        })
        let flipLocalVideoLabel = $('<label/>',{
            class: 'switch pe-none',
            html: [flipLocalVideoInput, flipLocalVideoSwitch]
        })
        let flipLocalVideoText = $('<span/>',{
            class: 'd-flex camera-settings-text-container',
            html: [flipLocalVideoIcon, ' Flip local video']
        })
        let flipLocalVideoContainer = $('<div/>',{
            class: `d-flex w-100 pt-1 justify-content-between align-items-center cursor-pointer kino-toggle ${Video.localVideo.cameraMutedByMe ? 'button-disabled' : ''}`,
            id: 'flip-local-video-container',
            html: [flipLocalVideoText, flipLocalVideoLabel]
        }).on('click', function(e){
            e.stopPropagation();
            flipLocalVideoInput.trigger('change')
        })
        let vbButton = $('<div/>',{
            class: 'dropdown-item d-flex w-100 cursor-pointer pt-1 align-self-center camera-settings-text-container',
            id: 'vb-camera-settings',
            html: [vb.blurIcon, 'Virtual Background']
        }).on('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            videoOptionClicked=false;
            // $("#videoDevicesList").trigger('mouseleave');
            vb.showPreviewModal();
        });

        //Privacy mode
        let privacyModeInput = $('<input/>',{
            type: 'checkbox',
            id: 'privacy-mode-camera-settings',
            checked: privacyMode.enabled ? true : false
        }).on('change', function(e){
            e.stopPropagation();
            if(!$(this).is(':disabled')){
                if($(this).is(':checked')){
                    $(this).prop('checked', false)
                    privacyMode.stopPrivacyMode();
                }else{
                    $(this).prop('checked', true)
                    privacyMode.startPrivacyMode();
                }
            }
        })
        let privacyModeSwitch = $('<span/>',{
            class: 'kino-slider round',
        })
        let privacyModeLabel = $('<label/>',{
            class: 'switch pe-none',
            html: [privacyModeInput, privacyModeSwitch]
        })

        let privacyModeText = $('<span/>',{
            class: 'd-flex align-self-center camera-settings-text-container',
            html: [privacyMode.privacyModeIcon, 'Privacy Mode'],
        })
        let privacyModeSection = $('<div/>',{
            class: `d-flex w-100 justify-content-between pt-1 align-items-center cursor-pointer kino-toggle ${Video.localVideo.cameraMutedByMe ? 'button-disabled' : ''}`,
            id: 'privacy-mode-camera-section',
            html: [privacyModeText, privacyModeLabel]
        }).on('click', function(e){
            e.stopPropagation();
            privacyModeInput.trigger('change')
        })

        let camMuted=isCameraMuted();
        let muteCamButton=$("<div/>", {
            class: `dropdown-item video-input-device dropdown-action ${camMuted ? '' : 'action-mute'}`,
            html: [``,`<span class="ellipsis">${camMuted ? 'Unmute' : 'Mute'} camera</span>`],
        }).on("click",(e)=>{
            e.preventDefault();
            e.stopPropagation();
            toggleCamera();
        });

        let cameraSettingsContainer = $('<div/>',{
            class: 'camera-settings-container',
            html: [`<h6 class="dropdown-header px-2 mt-3">Video settings</h6>`,flipLocalVideoContainer, privacyModeSection, vbButton,muteCamButton]
        })
        // videoDevicesList.append(`
        //     <h6 class="dropdown-header px-2 mt-3">Camera settings</h6>
        // `)
        videoDevicesList.append(cameraSettingsContainer)
    });
}
showAudioDevices.on("click", function () {
    DeviceListSettings();
});
showVideoDevices.on("click", function () {
    DeviceListSettings();
});

function ShareScreenList() {

    let optionTextOne = $('<span/>',{
        class: 'ellipsis',
        html: 'Share screen',
    })

    let optionTextTwo = $('<span/>',{
        class: 'ellipsis',
        html: 'Share screen on stage',
    })


    let optionIconOne = $('<i/>',{
        class: 'fas fa-solid fa-desktop mr-1',
    })

    let optionIconTwo = $('<i/>',{
        class: 'fas fa-solid fa-user mr-2',
    })

    let header = $('<h6/>',{
        class: 'dropdown-header px-2',
        html: 'Share Screen Options',
    })

    let optionOne = $('<a/>',{
        class: 'dropdown-item href="#"',
        html: [optionIconOne, optionTextOne],
    })

    let optionTwo = $('<a/>',{
        class: 'dropdown-item href="#"',
        html: [optionIconTwo, optionTextTwo],
    }).on("click", function (){
        // Video.stealFocus.renderScreenSharePlaceOnStageModal();
    });

    let container = $('<div/>',{
        class: '',
        html: [header, optionOne, optionTwo],
    })

    screenShareList.html(container)

}

shareScreenOptions.on("click", function () {
    ShareScreenList();
});

// SIDE MENU PARTICIPANT LIST OPTION

function displayKinoID(){
    $("#kino-id-side-menu").html(`Kino ID: ${ROOM_NAME}`);
    $("#numberOfParticipants").html(kinoParticipants.count());
    if(kinoParticipants.count() == 1){
        $("#numberOfParticipantsText").html('Participant');
    } else {
        $("#numberOfParticipantsText").html('Participants');
    }
}

$("#numberOfParticipantsContainer").on("click", function () {
    if($("#option-list").hasClass('d-none')){
        hideParticipantsList();
    }else{
        showParticipantsList();
    }
});

sideMenuParticipantBack.on("click", function () {
    hideParticipantsList();
});

$("#sideMenuParticipantBackText").on("click", function () {
    sideMenuParticipantBack.trigger('click');
});

function showParticipantsList(){
    let inputtext=Video.searchParticipantInput.val().toLowerCase();
    Video.searchParticipant(inputtext);
    $("#option-list").addClass('d-none');
    $("#sideMenuParticipant").removeClass('d-none');
    $("#sideMenuParticipantList").removeClass('d-none');
    $("#participant_search_name").removeClass('d-none');
    $(`#numberOfParticipantsContainer`).addClass("plist-shown");
    // $("#kinoIdNumberPart").addClass('d-none');
    sideMenuParticipantBack.addClass('show');
}
function hideParticipantsList(){
    $("#option-list").removeClass('d-none');
    $("#sideMenuParticipant").addClass('d-none');
    $("#sideMenuParticipantList").addClass('d-none');
    $("#participant_search_name").addClass('d-none');
    $(`#numberOfParticipantsContainer`).removeClass("plist-shown");
    // $("#kinoIdNumberPart").removeClass('d-none');
    sideMenuParticipantBack.removeClass('show');
}


$(document).on("click", ".audio-input-device", function () {
    console.log("audio device change clicked");
    if(!$(this).attr("device-id")){return}
    if (localRecording?.isRecording) {
        $("#recording-mic-device-change-modal").modal("show");
        return;
    }
    audioOptionClicked=true;
    setTimeout(() => {
        audioOptionClicked=false;
    }, 300);
    // $("#showAudioDevices").dropdown("hide")
    // audioDevicesList.trigger('mouseleave');
    audioDevicesList.find(".dropdown-item").removeClass("selected");
    $(this).addClass("selected");
    switchAudio($(this).attr("device-id"));

});

$(document).on("click", ".video-input-device", function () {
    if(!$(this).attr("device-id")){return}
    videoOptionClicked=true;
    setTimeout(() => {
        videoOptionClicked=false;
    }, 300);
    videoDevicesList.find(".dropdown-item").removeClass("selected");
  $(this).addClass("selected");
//   videoDevicesList.trigger('mouseleave');
  switchVideo($(this).attr("device-id"), $(this).attr("device-flip"));
});

/**
 *
 */
function switchAudio(selected) {
    var mic_state = muteMicButton.attr("data-original-title");
    console.log(mic_state);
    // eslint-disable-line no-unused-vars
    KinoJS.createLocalTracks({
        devices: ["audio"],
        constraints: {
            audio: {
                optional: [
                    {
                        sourceId: selected,
                    },
                    {
                        echoCancellationType: "browser",
                    },
                ],
            },
        },
        micDeviceId: selected
            ? {
                  exact: selected,
              }
            : "communications",
    })
        .then(async (tracks) => {
            const audioTrack = tracks.find(t=>t.deviceId==selected);
            console.log("got device with ID:" + audioTrack.deviceId);
            if (audioTrack) {
                let mic_muted = false;
                console.log("Changing audio device to :" + audioTrack.deviceId);
                if (isMicMuted()) {
                    mic_muted = true;
                    audioTrack.mute();
                }
                Video.micMuted(room.myUserId(), mic_muted);
                try {
                    await room.replaceTrack(room.getLocalAudioTrack(),audioTrack);
                    storeLocalTrack(audioTrack);
                    deviceManager.saveMic(room.getLocalAudioTrack().getDeviceId(),audioTrack.track.label);
                    noiseSuppression.active=false;
                    if(noiseSuppression.isEnabled()){
                        noiseSuppression.enableNoiseSuppression(true);
                    }
                } catch (error) {
                    console.error("Change mic error occured",error)
                }
            }

        })
        .catch((error) => {
            console.error("change mic error", error);
        });
}

/**
 *
 */
function switchVideo(selected) {
    // eslint-disable-line no-unused-vars
    console.log("requesting change device camera id: " + selected);
    console.log(
        "Is device change available " +
            KinoJS.mediaDevices.isDeviceChangeAvailable("video")
    );
    let trackCaptured = false;
    let shouldLimitResolution=false;
    let videoConstraints={...constraints};
    if(vb.effectPlaying || privacyMode.enabled){
        shouldLimitResolution=true;
        if(videoConstraints.video && shouldLimitResolution){
            videoConstraints.video['frameRate']={
                ideal:getFrameRate(),
                min: getFrameRate() < 30 ? 5 : 15,
                max: getFrameRate() >=30 ? 60 : getFrameRate()
            };
        }
    }
    return new Promise((resolve,reject)=>{
        KinoJS.createLocalTracks(
            {
                devices: ["video"],
                resolution: shouldLimitResolution ? getIdealResolution() : 720,
                constraints: videoConstraints,
                cameraDeviceId: {
                    exact: selected,
                },
            },
            true
        )
            .then(async (tracks) => {
                let videoTrack=tracks.find(v=>v.deviceId == selected);
                if (videoTrack) {
                    console.log("Found video track to replace")
                    // if (screenShare.isSharing()) {
                    //     //change presenter stream
                    //     if (vb.effectPlaying) {
                    //         videoTrack = await vb.runEffect(videoTrack);
                    //     } else if (privacyMode.enabled) {
                    //         videoTrack = await privacyMode.startPrivacyMode(
                    //             videoTrack
                    //         );
                    //     }
                    //     //Video.changePresenterStream(videoTrack);
                    //     deviceManager.saveCamera(videoTrack.deviceId,videoTrack.track.label);
                    //     screenShare.onCameraChanged(videoTrack);
                    // } else {
                        if (vb.effectPlaying) {
                            videoTrack = await vb.runEffect(videoTrack);
                        } else if (privacyMode.enabled) {
                            videoTrack = await privacyMode.startPrivacyMode(
                                videoTrack
                            );
                        }
                        const currentVideoTrack=getLocalTrack(MEDIA_TYPE.VIDEO);

                        try {
                            if(currentVideoTrack){
                                currentVideoTrack.kinoTrack.getTrack().stop();
                            }
                        } catch (e) {}
                        trackCaptured=true;
                        if(currentVideoTrack && currentVideoTrack.kinoTrack){
                            await room.replaceTrack(currentVideoTrack.kinoTrack, videoTrack)
                            // await room.removeTrack(currentVideoTrack.kinoTrack)
                            // await room.addTrack(videoTrack)
                        }else{
                            await room.addTrack(videoTrack)
                        }
                        stopMediaPlayers(Video.localVideo.wrapper);
                        storeLocalTrack(videoTrack);
                        deviceManager.saveCamera(videoTrack.deviceId,videoTrack.track.label);

                        if(vb.effectPlaying && vb.shouldDisableHighRes){
                            disableSimlucastLayers([2]);
                        }else if(privacyMode.enabled){
                            disableSimlucastLayers([1,2]);
                        }

                        if (!vb.effectPlaying) {
                            vb.cameraTrack = videoTrack;
                        }
                        room.setLocalParticipantProperty("video_muted",false);
                        Video.cameraMuted(room.myUserId(), false);
                    // }
                    muteCameraButton.html(cameraEnabledIcon);
                    resolve();
                }else{
                    reject(new Error('Could not capture video'))
                }
            })
            .catch(error => {
                if(trackCaptured){

                    Video.cameraMuted(room.myUserId(),true);
                    room.setLocalParticipantProperty("video_muted",true);
                    muteCameraButton.html(cameraDisabledIcon);
                    muteCameraButton.attr({
                        title: "The camera is being used by another application",
                        "data-original-title": "The camera is being used by another application",
                    });
                }
              console.log(error)
              reject(error)
            });
    })

}

async function getConnectedDevices(type) {
    const devices = await navigator.mediaDevices.enumerateDevices();
    return devices.filter((device) => device.kind === type);
}

// if (typeof Request == "function") {
//     var pingRequest = new Request(`${isElectron ? api.global.app_url : ''}/session/ping`);
//     try {
//         setInterval(() => {
//             pingRequest.post();
//         }, 10 * (60 * 1000));
//     } catch (err) {
//         console.warn("Can not send ping request");
//     }
// } else {
//     console.warn("Request class is not found");
// }

/**
 * Option side menu fucntions
 */
$(document).on("click keyup", (e) => {
    if (!$(e.target).closest("#options-side-menu").length) {
        if ($("#options-side-menu.active").length) {
            hideSideMenu();
        }
    }
    if (!$(e.target).closest(".connectionStats").length) {
        if ($(".connectionStats-popover.visible").length) {
            $('.connectionStats-popover').removeClass('visible')
        }
    }
    $('[data-toggle="tooltip"]').tooltip("hide");
});

function showSideMenu() {
    showKinoMenuDropUp.dropdown('show');
    // sideMenu.addClass("d-block");
    // showKinoMenuDropUp.trigger('click');
    // setTimeout(() => {
    //     sideMenu.addClass("show");
    // }, 300);
}

function hideSideMenu() {
    // sideMenu.removeClass("d-block");
    // showKinoMenuDropUp.trigger('click');
    showKinoMenuDropUp.dropdown('hide');
    // setTimeout(() => {
    //     hideParticipantsList();
    // }, 500);
    // sideMenu.removeClass("show");
}
function stopMediaPlayers(element) {
    try {
        // console.trace("stop Media player element", element);
        //stop all video players
        let videos = $(element).find("video");
        if (videos.length > 0) {
            $.each(videos, function (i, video) {
                // console.log("stopping video", video);
                video.pause();
                video.currentTime = 0;
                video.removeAttribute("src");
                video.srcObject = null;
                video.load();
                //video.remove();
            });
        }
        //stop all audio players
        let audios = $(element).find("audio");
        if (audios.length > 0) {
            $.each(audios, function (i, audio) {
                // console.log("stopping audio", audio);
                audio.pause();
                audio.currentTime = 0;
                audio.removeAttribute("src");
                audio.srcObject = null;
                audio.load();
                //video.remove();
            });
        }
        // console.warn("MediaPlayerRemover videos:", videos);
    } catch (error) {
        console.log("Failed to stop media element", error);
    }
}

function disablePrivacyModeBtn() {
    // console.error('DISABLE PROVACY MODE CALLED')
    $("#privacyModeBtn").addClass("button-disabled");
    $("#privacyModeBtn").attr({
        "data-toggle": "tooltip",
        "data-placement": "top",
        "data-original-title": "Stop screen sharing to change this switch",
    });
}

function setCameraOptionsPreferences(preferences){
    cameraOptionsPreferences=preferences;
    userPreferences.storeNewPreferences('camera_options',cameraOptionsPreferences);
};

function updateFlippedVideos(){
    if(vb.modal && vb.modal.hasClass('minimized-modal')){
        if(vb.videoContainer.hasClass('flipVideoX')){
            vb.videoContainer.removeClass('flipVideoX')
        }else{
            vb.videoContainer.addClass('flipVideoX')
        }
    }
    if(Video.splitConversations.modal && Video.splitConversations.modal.hasClass('minimized-modal')){
        if($(`.pid-${room.myUserId()}`) && $(`.pid-${room.myUserId()} .user-video`).hasClass('flipVideoX')){
            $(`.pid-${room.myUserId()} .user-video`).removeClass('flipVideoX')
        }else{
            $(`.pid-${room.myUserId()} .user-video`).addClass('flipVideoX')
        }

        if($(`#spl-participant-list .draggable-participant-${room.myUserId()}`)
            && $(`#spl-participant-list .draggable-participant-${room.myUserId()} video`).hasClass('flipVideoX')){
            $(`#spl-participant-list .draggable-participant-${room.myUserId()} video`).removeClass('flipVideoX')
        }else{
            $(`#spl-participant-list .draggable-participant-${room.myUserId()} video`).addClass('flipVideoX')
        }
    }
    if($(`.pid_${room.myUserId()}`) && $(`.pid_${room.myUserId()} div video`)){
        if($(`.pid_${room.myUserId()} div video`).hasClass('flipVideoX')){
            $(`.pid_${room.myUserId()} div video`).removeClass('flipVideoX')
        }else{
            $(`.pid_${room.myUserId()} div video`).addClass('flipVideoX')
        }
    }
}

function storeLastSpaceId(id){
    localStorage.setItem('last_space',id);
}

function getFrameRate(){
    let framerate=15;
        try {
            if(navigator && navigator.hardwareConcurrency){
            if(navigator.hardwareConcurrency > 12){
                framerate=30;
            }else if(navigator.hardwareConcurrency <= 12 && navigator.hardwareConcurrency > 4){
                framerate=20;
            }else if(navigator.hardwareConcurrency <= 4){
                framerate=15;
            }
        }
    } catch (error) {}
    return framerate;

};
function setCodecBasedOnCPU(){
    let preferedCodec="VP9";

    try {
       if(navigator.hardwareConcurrency <= 8){
            preferedCodec="VP9";
            if(confOptions && confOptions.videoQuality && !confOptions.videoQuality?.enforcePreferredCodec){
                console.log(`Detected cpu's ${navigator.hardwareConcurrency}, setting preferred codec ${preferedCodec}`);
                confOptions.videoQuality.preferredCodec=preferedCodec;
                // confOptions.videoQuality.enforcePreferredCodec=true;
            }
        }
    } catch (error) {
        console.log(`Error setting preferred codec`,error);
    }
}
function getIdealResolution(){
    return getFrameRate() > 15 ? 720 : 360
};


var audioMenuTimeout;
var videoMenuTimeout;
var audioOptionClicked=false;
var videoOptionClicked=false;
// Function for dropdown audio devices on hover of Microphone button
$("#room-mute-mic").on({
    mouseenter: function() {
        let isShown=$( "#showAudioDevices" ).attr("aria-expanded");
        clearTimeout(videoMenuTimeout);
        if(isShown=="false"){
            $( "#showAudioDevices" ).click();
        }
        $(muteMicButton).tooltip('hide')
    },
    mouseleave: function() {
        let isShown=$( "#showAudioDevices" ).attr("aria-expanded");

        if(isShown=="true"){

            audioMenuTimeout=setTimeout(()=>{

                //check if user is interacting with menu
                let isInteracting=$("#audioDevicesList").attr("aria-action");
                if(isInteracting=="false"){
                    $( "#showAudioDevices" ).click();
                }
            },350);

        }
    }
});



// Function for dropdown camera devices on hover of Camera button
$("#room-mute-video").on({
    mouseenter: function() {
        let isShown=$( "#showCameraDevices" ).attr("aria-expanded");
        clearTimeout(audioMenuTimeout);

        if(isShown=="false"){
            $( "#showCameraDevices" ).click();
        }
        $(muteCameraButton).tooltip('hide');
    },
    mouseleave: function() {
        let isShown=$( "#showCameraDevices" ).attr("aria-expanded");

        if(isShown=="true"){

            videoMenuTimeout=setTimeout(()=>{

                //check if user is interacting with menu
                let isInteracting=$("#videoDevicesList").attr("aria-action");
                if(isInteracting=="false"){
                    $( "#showCameraDevices" ).click();
                }
            },350);

        }
    }
});

$("#optionsBtn").on({
    mouseenter: function() {
        let isShown=$( "#optionsBtn" ).attr("aria-expanded");
        clearTimeout(audioMenuTimeout);

        if(isShown=="false"){
            $( "#optionsBtn" ).click();
        }
        $(muteCameraButton).tooltip('hide');
    },
    mouseleave: function() {
        let isShown=$( "#optionsBtn" ).attr("aria-expanded");

        if(isShown=="true"){

            videoMenuTimeout=setTimeout(()=>{

                //check if user is interacting with menu
                let isInteracting=$("#options-side-menu").attr("aria-action");
                if(isInteracting=="false"){
                    $( "#optionsBtn" ).click();
                }
            },350);

        }
    }
});


$("#audioDevicesList").mouseenter(function() {
    if(audioOptionClicked){return}
    console.log("mouse enter")
    $(this).attr("aria-action",true);
});
$("#audioDevicesList").mouseleave(function() {
    if(audioOptionClicked){return}

    console.log("mouse leave")
    $(this).attr("aria-action",false);
    clearTimeout(audioMenuTimeout);
    $( "#showAudioDevices" ).click();
});

$("#videoDevicesList").mouseenter(function() {
    if(videoOptionClicked){return}
    $(this).attr("aria-action",true);
});
$("#videoDevicesList").mouseleave(function() {
    if(videoOptionClicked){return}
    $(this).attr("aria-action",false);
    clearTimeout(videoMenuTimeout);
    $( "#showCameraDevices" ).click();
});

export {socket,room,CONV_STORAGE,Video,isMobile,cameraEnabledIcon
  ,vb,privacyMode,deviceManager,
  switchVideo,showSideMenu,
  hideSideMenu,conversationTooltipTimeout,
  stopMediaPlayers,chat, localRecording,
  unload,disablePrivacyModeBtn,
  kinoTimer,
  live_stream,
  lockFocus,
  micIcon,
  micMutedIcon,
  muteParticipants,
  bottomAction,
  joinRequest,
  kinoLimits,
  convertPath,electronConfig,isElectron,
  isMac,isWindows,
  isJoined,
  screenSharingIcon,
  screenSharingDisableIcon,
  cameraDisabledIcon,
  timerComponent,
  userPreferences,
  screenShare,
  lobby,
  onLocalTracks,
  initSocketMessage,
  startRoom,
  connection,
  strTest,
  muteMic,unMuteMic,unMuteCamera,
  cameraOptionsPreferences,
  animatedLayers,
  kinoParticipants,
  volumeManager,
  muteMicButton,
  getFrameRate,
  getIdealResolution,
  buttonSpam,
  onStage,
  spacesView,
  hideParticipantsList,
  muteAll,
  kinoControls,
  isEdge,
  pictureInPicture,
  isCameraMuted,
  isMicMuted,
  toggleMic,
  toggleCamera,
  noiseSuppression,
  permissions,
  renderKinoMenu,
  getKinoRole
};
